import { render } from "./web-categories-readonly.vue?vue&type=template&id=22ba7aaf"
import script from "./web-categories-readonly.vue?vue&type=script&lang=js"
export * from "./web-categories-readonly.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__